import React from 'react'
import Helper from '../functions/Helper.js'
import {useHistory} from "react-router-dom";

export default function RatingBar(props){
  let rating=isNaN(props.rating) || props.rating==-1 ? "NA" : props.category==="Outdoor" ? Math.round(props.rating)+"%" : Helper.roundto(props.rating,1);
  let barWidth=rating ==="NA" ? "0%" : (props.category==="Outdoor" ? Math.max(0,props.rating) +"%" : Math.max(0,(props.rating-4)*100/6) +"%");
  let barHeight=props.size==="small"? 26: 32;
  let history=useHistory();

  const scrollToSection=()=>{
    Helper.gaEvent("reviews","Rating Bar", "Click" +props.category);
    document.getElementById(props.category).scrollIntoView({behavior:'smooth',block:'start',inline: 'nearest'})
    history.push("#"+props.category);
  }

  return(
    	<div style={{cursor:"pointer",display:"flex",marginTop:props.size==="small"? 10: 15}} onClick={scrollToSection}  className='rating_bar'>
    		<div style={{fontSize: props.size==="small"? 16 : 18, flex:1,overflow:"hidden",borderRadius:3,height:barHeight}}>
          <div className='rating_bar' style={{width:"100%",backgroundColor: "rgb(239, 239, 239)"}}>
            <div className='rating_bar' style={{transition:"width 0.5s",lineHeight:barHeight+'px', fontSize:props.size==="small"? 14 : 16, width:barWidth,minWidth:"100px",paddingLeft:15, paddingRight:15,color: 'white', fontWeight:'bold', backgroundColor: Helper.get_color(props.rating,props.category==="Outdoor" ? "outdoor" : "bg")}}>
              {props.category}
            </div>
          </div>
        </div>
    		<div className='rating_bar' style={{width:45,color:"var(--primary-color-600)",textAlign:"right",fontSize:props.size==="small"? 16:18, lineHeight:barHeight+"px", fontWeight:'bold',}}>
          {rating}
        </div>
    	</div>
    );
  }
